import { render, staticRenderFns } from "./Homework_bank.vue?vue&type=template&id=5219a061"
import script from "./Homework_bank.vue?vue&type=script&lang=js"
export * from "./Homework_bank.vue?vue&type=script&lang=js"
import style0 from "./Homework_bank.vue?vue&type=style&index=0&id=5219a061&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports